// SPDX-License-Identifier: AGPL-3.0-or-later

import * as AnalyticsCommands from '@app/features/analytics/commands/AnalyticsCommands';
import styles from '@app/features/analytics/components/AnalyticsPreferencesLink.module.css';
import AnalyticsConsent from '@app/features/analytics/state/AnalyticsConsent';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';

const TURN_OFF_DESCRIPTOR = msg({
	message: 'Turn off analytics cookies',
	comment:
		'Link under the sign-in and registration forms while Google Analytics is on. Turns it off and deletes its cookies, so a signed-out visitor can opt out.',
});
const TURN_ON_DESCRIPTOR = msg({
	message: 'Turn on analytics cookies',
	comment: 'Link under the sign-in and registration forms after Google Analytics was turned off. Turns it back on.',
});

// Settings > Privacy needs a session; this is the opt-out on the auth pages, where analytics also runs.
export const AnalyticsPreferencesLink = observer(() => {
	const {i18n} = useLingui();
	if (!AnalyticsConsent.isAvailable) return null;
	const granted = AnalyticsConsent.isGranted;
	return (
		<div className={styles.row} data-flx="analytics.analytics-preferences-link.row">
			<button
				type="button"
				className={styles.link}
				onClick={granted ? AnalyticsCommands.reject : AnalyticsCommands.accept}
				data-flx="analytics.analytics-preferences-link.link"
			>
				{i18n._(granted ? TURN_OFF_DESCRIPTOR : TURN_ON_DESCRIPTOR)}
			</button>
		</div>
	);
});
